/* tslint:disable */
/* eslint-disable */
/**
 * Lease API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: api@vendingontrack.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ConfirmReturnResponse
 */
export interface ConfirmReturnResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmReturnResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfirmReturnResponse
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface CustomerLease
 */
export interface CustomerLease {
    /**
     * 
     * @type {string}
     * @memberof CustomerLease
     */
    'txnRef'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'createdEpoch'?: number;
    /**
     * 
     * @type {CustomerLeaseState}
     * @memberof CustomerLease
     */
    'state'?: CustomerLeaseState;
    /**
     * 
     * @type {CustomerStock}
     * @memberof CustomerLease
     */
    'stock'?: CustomerStock;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'dispenseEpoch'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'returnEpoch'?: number;
    /**
     * 
     * @type {CustomerLockerCell}
     * @memberof CustomerLease
     */
    'dispenseCell'?: CustomerLockerCell;
    /**
     * 
     * @type {CustomerLockerCell}
     * @memberof CustomerLease
     */
    'returnCell'?: CustomerLockerCell;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'deposit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLease
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerLease
     */
    'paymentUrl'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomerLeaseState {
    PendingPayment = 'PENDING_PAYMENT',
    PaymentTimeoutCancelled = 'PAYMENT_TIMEOUT_CANCELLED',
    PaymentRejectedCancelled = 'PAYMENT_REJECTED_CANCELLED',
    PendingDispense = 'PENDING_DISPENSE',
    Dispensed = 'DISPENSED',
    AttemptReturn = 'ATTEMPT_RETURN',
    PendingReturn = 'PENDING_RETURN',
    TimeoutReturned = 'TIMEOUT_RETURNED',
    CustomerReturned = 'CUSTOMER_RETURNED',
    Reported = 'REPORTED',
    ReturnedConfirmed = 'RETURNED_CONFIRMED'
}

/**
 * 
 * @export
 * @interface CustomerLocker
 */
export interface CustomerLocker {
    /**
     * 
     * @type {string}
     * @memberof CustomerLocker
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerLocker
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CustomerLockerCell
 */
export interface CustomerLockerCell {
    /**
     * 
     * @type {CustomerLocker}
     * @memberof CustomerLockerCell
     */
    'locker'?: CustomerLocker;
    /**
     * 
     * @type {string}
     * @memberof CustomerLockerCell
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerLockerCell
     */
    'row'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerLockerCell
     */
    'col'?: string;
    /**
     * 
     * @type {CustomerStock}
     * @memberof CustomerLockerCell
     */
    'stock'?: CustomerStock;
}
/**
 * 
 * @export
 * @interface CustomerProduct
 */
export interface CustomerProduct {
    /**
     * 
     * @type {string}
     * @memberof CustomerProduct
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerProduct
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerProduct
     */
    'imageUrl'?: string;
}
/**
 * 
 * @export
 * @interface CustomerStock
 */
export interface CustomerStock {
    /**
     * 
     * @type {string}
     * @memberof CustomerStock
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerStock
     */
    'code'?: string;
    /**
     * 
     * @type {CustomerProduct}
     * @memberof CustomerStock
     */
    'product'?: CustomerProduct;
}
/**
 * 
 * @export
 * @interface ListLeasesResponse
 */
export interface ListLeasesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ListLeasesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListLeasesResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<CustomerLease>}
     * @memberof ListLeasesResponse
     */
    'leases'?: Array<CustomerLease>;
}
/**
 * 
 * @export
 * @interface ListProductResponse
 */
export interface ListProductResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ListProductResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListProductResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<CustomerProduct>}
     * @memberof ListProductResponse
     */
    'products'?: Array<CustomerProduct>;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }  Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...  Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON  The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface QueryLeaseResponse
 */
export interface QueryLeaseResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueryLeaseResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryLeaseResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {CustomerLease}
     * @memberof QueryLeaseResponse
     */
    'lease'?: CustomerLease;
}
/**
 * The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details.  You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors).
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
     * @type {number}
     * @memberof RpcStatus
     */
    'code'?: number;
    /**
     * A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
     * @type {string}
     * @memberof RpcStatus
     */
    'message'?: string;
    /**
     * A list of messages that carry the error details.  There is a common set of message types for APIs to use.
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    'details'?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @interface SigninRequest
 */
export interface SigninRequest {
    /**
     * 
     * @type {string}
     * @memberof SigninRequest
     */
    'mobile'?: string;
}
/**
 * 
 * @export
 * @interface SigninResponse
 */
export interface SigninResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SigninResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigninResponse
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface StartLeaseRequest
 */
export interface StartLeaseRequest {
    /**
     * 
     * @type {string}
     * @memberof StartLeaseRequest
     */
    'productUuid'?: string;
}
/**
 * 
 * @export
 * @interface StartLeaseResponse
 */
export interface StartLeaseResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StartLeaseResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StartLeaseResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof StartLeaseResponse
     */
    'leaseUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof StartLeaseResponse
     */
    'leasePaymentUrl'?: string;
}
/**
 * 
 * @export
 * @interface TerminateLeaseResponse
 */
export interface TerminateLeaseResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TerminateLeaseResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TerminateLeaseResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {CustomerLockerCell}
     * @memberof TerminateLeaseResponse
     */
    'returnCell'?: CustomerLockerCell;
}
/**
 * 
 * @export
 * @interface VerifyAuthCodeRequest
 */
export interface VerifyAuthCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'authCode'?: string;
}
/**
 * 
 * @export
 * @interface VerifyAuthCodeResponse
 */
export interface VerifyAuthCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyAuthCodeResponse
     */
    'loginSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeResponse
     */
    'authToken'?: string;
}

/**
 * AuthenticationAPIServiceApi - axios parameter creator
 * @export
 */
export const AuthenticationAPIServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationAPIServiceSignin: async (body: SigninRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authenticationAPIServiceSignin', 'body', body)
            const localVarPath = `/api/v1/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationAPIServiceVerifyAuthCode: async (body: VerifyAuthCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authenticationAPIServiceVerifyAuthCode', 'body', body)
            const localVarPath = `/api/v1/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationAPIServiceApi - functional programming interface
 * @export
 */
export const AuthenticationAPIServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationAPIServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationAPIServiceSignin(body: SigninRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationAPIServiceSignin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyAuthCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationAPIServiceVerifyAuthCode(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationAPIServiceApi - factory interface
 * @export
 */
export const AuthenticationAPIServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationAPIServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationAPIServiceSignin(body: SigninRequest, options?: any): AxiosPromise<SigninResponse> {
            return localVarFp.authenticationAPIServiceSignin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: any): AxiosPromise<VerifyAuthCodeResponse> {
            return localVarFp.authenticationAPIServiceVerifyAuthCode(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationAPIServiceApi - object-oriented interface
 * @export
 * @class AuthenticationAPIServiceApi
 * @extends {BaseAPI}
 */
export class AuthenticationAPIServiceApi extends BaseAPI {
    /**
     * 
     * @param {SigninRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAPIServiceApi
     */
    public authenticationAPIServiceSignin(body: SigninRequest, options?: AxiosRequestConfig) {
        return AuthenticationAPIServiceApiFp(this.configuration).authenticationAPIServiceSignin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyAuthCodeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAPIServiceApi
     */
    public authenticationAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: AxiosRequestConfig) {
        return AuthenticationAPIServiceApiFp(this.configuration).authenticationAPIServiceVerifyAuthCode(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LeaseAPIServiceApi - axios parameter creator
 * @export
 */
export const LeaseAPIServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceConfirmReturn: async (txnRef: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'txnRef' is not null or undefined
            assertParamExists('leaseAPIServiceConfirmReturn', 'txnRef', txnRef)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('leaseAPIServiceConfirmReturn', 'body', body)
            const localVarPath = `/api/v1/leases/{txnRef}/return-confirmation`
                .replace(`{${"txnRef"}}`, encodeURIComponent(String(txnRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceListLeases: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/leases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceQueryLease: async (txnRef: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'txnRef' is not null or undefined
            assertParamExists('leaseAPIServiceQueryLease', 'txnRef', txnRef)
            const localVarPath = `/api/v1/leases/{txnRef}`
                .replace(`{${"txnRef"}}`, encodeURIComponent(String(txnRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartLeaseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceStartLease: async (body: StartLeaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('leaseAPIServiceStartLease', 'body', body)
            const localVarPath = `/api/v1/leases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceTerminateLease: async (txnRef: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'txnRef' is not null or undefined
            assertParamExists('leaseAPIServiceTerminateLease', 'txnRef', txnRef)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('leaseAPIServiceTerminateLease', 'body', body)
            const localVarPath = `/api/v1/leases/{txnRef}/termination`
                .replace(`{${"txnRef"}}`, encodeURIComponent(String(txnRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaseAPIServiceApi - functional programming interface
 * @export
 */
export const LeaseAPIServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeaseAPIServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaseAPIServiceConfirmReturn(txnRef: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmReturnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaseAPIServiceConfirmReturn(txnRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaseAPIServiceListLeases(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLeasesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaseAPIServiceListLeases(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaseAPIServiceQueryLease(txnRef: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryLeaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaseAPIServiceQueryLease(txnRef, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartLeaseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaseAPIServiceStartLease(body: StartLeaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartLeaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaseAPIServiceStartLease(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaseAPIServiceTerminateLease(txnRef: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminateLeaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaseAPIServiceTerminateLease(txnRef, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LeaseAPIServiceApi - factory interface
 * @export
 */
export const LeaseAPIServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeaseAPIServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceConfirmReturn(txnRef: string, body: object, options?: any): AxiosPromise<ConfirmReturnResponse> {
            return localVarFp.leaseAPIServiceConfirmReturn(txnRef, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceListLeases(options?: any): AxiosPromise<ListLeasesResponse> {
            return localVarFp.leaseAPIServiceListLeases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceQueryLease(txnRef: string, options?: any): AxiosPromise<QueryLeaseResponse> {
            return localVarFp.leaseAPIServiceQueryLease(txnRef, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartLeaseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceStartLease(body: StartLeaseRequest, options?: any): AxiosPromise<StartLeaseResponse> {
            return localVarFp.leaseAPIServiceStartLease(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} txnRef 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaseAPIServiceTerminateLease(txnRef: string, body: object, options?: any): AxiosPromise<TerminateLeaseResponse> {
            return localVarFp.leaseAPIServiceTerminateLease(txnRef, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeaseAPIServiceApi - object-oriented interface
 * @export
 * @class LeaseAPIServiceApi
 * @extends {BaseAPI}
 */
export class LeaseAPIServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} txnRef 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaseAPIServiceApi
     */
    public leaseAPIServiceConfirmReturn(txnRef: string, body: object, options?: AxiosRequestConfig) {
        return LeaseAPIServiceApiFp(this.configuration).leaseAPIServiceConfirmReturn(txnRef, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaseAPIServiceApi
     */
    public leaseAPIServiceListLeases(options?: AxiosRequestConfig) {
        return LeaseAPIServiceApiFp(this.configuration).leaseAPIServiceListLeases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} txnRef 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaseAPIServiceApi
     */
    public leaseAPIServiceQueryLease(txnRef: string, options?: AxiosRequestConfig) {
        return LeaseAPIServiceApiFp(this.configuration).leaseAPIServiceQueryLease(txnRef, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartLeaseRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaseAPIServiceApi
     */
    public leaseAPIServiceStartLease(body: StartLeaseRequest, options?: AxiosRequestConfig) {
        return LeaseAPIServiceApiFp(this.configuration).leaseAPIServiceStartLease(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} txnRef 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaseAPIServiceApi
     */
    public leaseAPIServiceTerminateLease(txnRef: string, body: object, options?: AxiosRequestConfig) {
        return LeaseAPIServiceApiFp(this.configuration).leaseAPIServiceTerminateLease(txnRef, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductAPIServiceApi - axios parameter creator
 * @export
 */
export const ProductAPIServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAPIServiceListProducts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductAPIServiceApi - functional programming interface
 * @export
 */
export const ProductAPIServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductAPIServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productAPIServiceListProducts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productAPIServiceListProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductAPIServiceApi - factory interface
 * @export
 */
export const ProductAPIServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductAPIServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAPIServiceListProducts(options?: any): AxiosPromise<ListProductResponse> {
            return localVarFp.productAPIServiceListProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductAPIServiceApi - object-oriented interface
 * @export
 * @class ProductAPIServiceApi
 * @extends {BaseAPI}
 */
export class ProductAPIServiceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAPIServiceApi
     */
    public productAPIServiceListProducts(options?: AxiosRequestConfig) {
        return ProductAPIServiceApiFp(this.configuration).productAPIServiceListProducts(options).then((request) => request(this.axios, this.basePath));
    }
}


